import { CommonModule } from '@angular/common';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { AppSettings } from 'src/app/config';
import { MaterialModule } from 'src/app/material.module';
import { CoreService } from 'src/app/services/core.service';
import { DEFAULT_LANGUAGE } from 'src/app/shared/constants';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrl: './public-layout.component.scss',
  imports: [RouterOutlet, MaterialModule, CommonModule, TranslateModule]
})
export class PublicLayoutComponent implements OnInit {
  private htmlElement!: HTMLHtmlElement;

  options = this.settings.getOptions();

  constructor(
    private settings: CoreService,
    private translate: TranslateService,
    private renderer: Renderer2,
    private router: Router,
  ) {
    this.htmlElement = document.querySelector('html')!;
    // Initialize project theme with options
    this.receiveOptions(this.options);
    this.translate.setDefaultLang(DEFAULT_LANGUAGE);
  }

  receiveOptions(options: AppSettings): void {
    this.useLightTheme();
    this.toggleColorsTheme(options);
  }
  ngOnInit() {
    const currentPath = this.router.url;
    this.updateBodyClass(currentPath);
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.updateBodyClass(event.urlAfterRedirects);
    });
  }

  private updateBodyClass(path: string) {
    if (path.startsWith('/admin')) {
      this.renderer.addClass(document.body, 'admin');
    } else {
      this.renderer.removeClass(document.body, 'admin');
    }
  }
  
  private useLightTheme() {
    this.htmlElement.classList.remove('dark-theme');
    this.htmlElement.classList.add('light-theme');
  }

  toggleColorsTheme(options: AppSettings) {
    // Remove any existing theme class dynamically
    this.htmlElement.classList.forEach((className) => {
      if (className.endsWith('_theme')) {
        this.htmlElement.classList.remove(className);
      }
    });

    // Add the selected theme class
    this.htmlElement.classList.add(options.activeTheme);
  }
}
